module.exports = __webpack_public_path__ + "img/95.5.COD.a64019f9.png";